import React, { useState, useMemo } from 'react';

const PaymentModal = ({ onClose, onSelectPlan, currentGenerations, userEmail }) => {
  const [selectedTier, setSelectedTier] = useState('pro');

  const tiers = useMemo(() => [
    {
      id: 'starter',
      name: 'Starter',
      price: '$11.99',
      priceUSD: '11.99',
      period: '/month',
      generations: 200,
      description: '200 generations',
      paymentLink: process.env.REACT_APP_STRIPE_STARTER_LINK || '#'
    },
    {
      id: 'pro',
      name: 'Pro',
      price: '$24.99',
      priceUSD: '24.99',
      period: '/month',
      generations: 450,
      description: '450 generations',
      popular: true,
      paymentLink: process.env.REACT_APP_STRIPE_PRO_LINK || '#'
    },
    {
      id: 'business',
      name: 'Business',
      price: '$99.99',
      priceUSD: '99.99',
      period: '/month',
      generations: 2000,
      description: '2000 generations',
      paymentLink: process.env.REACT_APP_STRIPE_BUSINESS_LINK || '#'
    }
  ], []);

  // Payment verification now handled server-side via Stripe webhooks
  // Users will be redirected to success page after payment
  // Webhook will activate their plan in the database

  const handlePurchase = () => {
    const tier = tiers.find(t => t.id === selectedTier);
    
    if (!tier.paymentLink || tier.paymentLink === '#') {
      alert('Stripe payment links not configured yet. Please add them to your .env file.');
      return;
    }
    
    console.log('🔗 [Stripe] Redirecting to payment link for:', tier.name);
    console.log('💳 [Stripe] Price:', tier.price, 'Generations:', tier.generations);
    console.log('📧 [Stripe] User email:', userEmail);

    // Redirect to Stripe Payment Link with user email and plan ID
    // Webhook will use these to activate the plan after payment
    const paymentUrl = `${tier.paymentLink}?prefilled_email=${encodeURIComponent(userEmail || '')}&client_reference_id=${tier.id}`;

    window.location.href = paymentUrl;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal payment-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <h2 style={{ marginTop: '0.5rem' }}>Upgrade Your Plan</h2>
        <p style={{ marginBottom: '3rem' }}>
          You've used {currentGenerations} free generations. Choose a plan to continue.
        </p>

        <div className="payment-tiers">
          {tiers.map(tier => (
            <div
              key={tier.id}
              className={`tier-card ${selectedTier === tier.id ? 'selected' : ''} ${tier.popular ? 'popular' : ''}`}
              onClick={() => setSelectedTier(tier.id)}
            >
              {tier.popular && <div className="tier-badge">Most Popular</div>}
              
              <div className="tier-name">{tier.name}</div>
              
              <div className="tier-price">
                <span className="price-amount">{tier.price}</span>
                <span className="price-period">USD{tier.period}</span>
              </div>
              
              <div className="tier-description">{tier.description}</div>
            </div>
          ))}
        </div>

        <button className="modal-button" onClick={handlePurchase}>
          Continue to Payment
        </button>

        <button className="modal-button secondary" onClick={onClose}>
          Not right now
        </button>
      </div>
    </div>
  );
};

export default PaymentModal;

